import axios from '@/controllers/request'

/**
 * 通义万相模型文件上传
 * @param file 文件对象
 * @param assistantId 助手ID
 * @param conversationId 会话ID
 * @returns 上传结果，包含 file_path 和 crop_file_path
 */
export const uploadWanxiangFile = async (
  file: File,
  assistantId: string,
  conversationId: string
): Promise<{ file_path: string; crop_file_path?: string; file_name?: string }> => {
  const formData = new FormData()
  formData.append('file', file)

  return await axios.post('/api/v1/common/upload_file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'chat-alias-id': conversationId,
      'assistant-id': assistantId
    }
  })
}

/**
 * 查询视频任务状态
 * @param taskId 任务ID
 * @returns 任务状态信息
 */
export const getVideoTaskStatus = async (
  taskId: string
): Promise<{
  status: string
  video_url?: string
  task_id?: string
  thumbnail_url?: string
}> => {
  return await axios.get(`/api/v1/video/tasks/${taskId}`)
}

/**
 * 取消视频任务
 * @param taskId 任务ID
 */
export const cancelVideoTaskAPI = async (taskId: string): Promise<void> => {
  await axios.post(`/api/v1/video/tasks/${taskId}/cancel`)
}

/**
 * 校验视频生成权益
 * 发送前调用，判断当前用户是否有对应类型视频的生成权限
 * @param generate_type 视频生成类型：t2v（文生视）、p2v（图生视）、v2v（视生视）
 * @returns check_status true=有权益 false=无权益
 */
export const checkVideoBenefit = async (generate_type: 't2v' | 'p2v' | 'v2v'): Promise<{ check_status: boolean }> => {
  return await axios.post('/api/v1/video/benefit/check', { generate_type })
}
